import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Params, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../../../retailer.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-createcomments',
  templateUrl: './createcomments.component.html',
  styleUrls: ['./createcomments.component.scss']
})
export class CreatecommentsComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  addCommentForm: FormGroup;
  retailerId: any;
  visitTypes: any[];
  storeName: any;
  retailerName: any;
  accountNumber: any;
  newDate = new Date();
  constructor(private cdref: ChangeDetectorRef, 
                private fb: FormBuilder, 
              public dialog: MatDialog, 
              private router: Router,
              private activeRoute:ActivatedRoute, 
              private retailerService: RetailerService) { 
    super();
    this.uiConfigValuesService.getUIConfigValues('VisitTypes').subscribe(res=> {
      this.visitTypes = res['data'];
    })
    this.retailerId = this.activeRoute.snapshot.params.retailerId;
    this.retailerService.getSelectedRetailer(this.retailerId).subscribe(res => {
      if (res['httpcode'] == 200) {
        this.storeName = res.data.retailerDetails.dbaName;
        this.retailerName = res.data?.retailerDetails?.businessName;
        this.accountNumber = res.data?.retailerAccounts?.retailerAccountNum;
      }
    })
    this.addCommentForm = this.fb.group({
      callDuration: ['', [Validators.required]],
      comment: ['', [Validators.required]],
      spokeWith: ['', [Validators.required]],
      visitType: ['Call', [Validators.required]],
      visitedDate: ['', [Validators.required]],
      visitedTime: ['', [Validators.required]]
    })
  }

  ngOnInit(): void {
    this.initForm();
  }
  private initForm() {
 
  }

  get f() {
    return this.addCommentForm.controls;
  }

  onSubmit() {
   
    if (this.addCommentForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.addCommentForm)
        }else{
          this.router.navigate([`features/retailers/manageretailer/${this.retailerId}/comments/${this.retailerId}`])
        }
      });

    }
    //
  }

  setSubmitParameters(addCommentForm: FormGroup) {

    let httpParams: Params = {
      callDuration: addCommentForm.get('callDuration').value,
      comment: addCommentForm.get('comment').value,
      spokeWith: addCommentForm.get('spokeWith').value,
      visitType: addCommentForm.get('visitType').value,
      visitedDate: addCommentForm.get('visitedDate').value,
      visitedTime: addCommentForm.get('visitedTime').value,
      retailerId: this.retailerId,
    }
    //

    this.retailerService.addNewComment(httpParams).subscribe(res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_110") || res.responseStatus == 'Success'){
            this.router.navigate([`features/retailers/manageretailer/${this.retailerId}/comments/${this.retailerId}`])
            this.toastrService.success('Added Comment successfully', 'Success', {
              timeOut: 3000,
            });        
        }
      }
    });
  }


  onCancel() {
    for (const name in this.addCommentForm.controls) {
      if (this.addCommentForm.controls[name].invalid) {
       
      } else {
       
      }
    }

    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        //this.addCommentForm.reset()
        //window.location.reload()

        this.router.navigate([`features/retailers/manageretailer/${this.retailerId}/comments/${this.retailerId}`])
      }
    });
  }
}
